module.exports = __webpack_public_path__ + "img/dingd.fd574a99.jpg";